import { IonButton, IonIcon, IonItem, IonLabel } from '@ionic/react'
import { closeOutline } from 'ionicons/icons'
import { Input } from '../../../../components/Atoms/Input/Input'

interface Props {
  setIsOpenModalRegisterPayment: React.Dispatch<React.SetStateAction<boolean>>
  setIsOpenModalSuccessPayment: React.Dispatch<React.SetStateAction<boolean>>
}

export function ModalRegisterPayment ({ setIsOpenModalRegisterPayment, setIsOpenModalSuccessPayment }: Props) {
  const handleFinish = () => {
    setIsOpenModalRegisterPayment(false)
    setIsOpenModalSuccessPayment(true)
  }

  return (
		<div style={{ minWidth: '100%' }}>
			<IonItem className='ion-no-padding ion-no-margin' lines='none'>
        <IonIcon icon={closeOutline} size='small' slot='start' onClick={() => { setIsOpenModalRegisterPayment(false) }} className='ion-padding-start' />
      </IonItem>
			<div>
				<IonItem className='ion-no-padding ion-no-margin ion-text-center ion-padding-start' lines='none'>
					<IonLabel>
						Esta cantidad (propina incluida) solo se utiliza para identificación. No recibirá ningún depósito por esta transacción.
					</IonLabel>
				</IonItem>
				<div>
					<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '0', padding: '0 1rem' }}>
						<div style={{ flex: 1 }}>
							<Input noSpace label="Cantidad de devisión" type="number" name="ammout" value={'1351.00'} onChange={e => { console.log(e) }} />
						</div>
						<IonButton color="secondary" expand="block" fill='outline' onClick={() => { handleFinish() }} style={{ minHeight: '100%' }}>Registrar pago</IonButton>
					</div>
					<IonItem className='ion-no-padding ion-no-margin ion-text-center ion-padding-start' lines='none'>
						<IonLabel>
							Los montos de propina se enumeran por separado en los informes de ventas.
						</IonLabel>
					</IonItem>
				</div>
			</div>
    </div>
  )
}
